module.exports = __webpack_public_path__ + "static/media/head-side-brain.6f113dd0.svg";